<div class="container p-4 md:p-8 bg-white rounded-lg shadow-lg space-y-6">
  <h1 class="text-2xl font-semibold">Cadastro de Fornecedores</h1>

  <form #vendedorForm="ngForm" name="vendedorForm" class="space-y-4">
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="flex flex-col">
        <label for="nome" class="mb-1 font-medium text-gray-700">Nome</label>
        <input pInputText id="nome" placeholder="Nome" [(ngModel)]="fornecedor.nome" name="nome" class="w-full p-inputtext p-component rounded" />
      </div>

      <div class="flex flex-col">
        <label for="celular" class="mb-1 font-medium text-gray-700">Celular</label>
        <p-inputMask id="celular" mask="(99) 9 9999-9999" placeholder="Celular" [(ngModel)]="fornecedor.celular" name="celular" class="w-full rounded"></p-inputMask>
      </div>
    </div>

    <div class="flex space-x-4 pt-4">
      <div class="button-group">
        <button *ngIf="!editMode" pButton type="button" class="btn btn-primary btn-md" (click)="cadastrar()">
          <i class="pi pi-check mr-2"></i>
          <span>Cadastrar</span>
        </button>
        <button *ngIf="editMode" pButton type="button" class="btn btn-primary btn-md" (click)="salvarAlteracao()">
          <i class="pi pi-save mr-2"></i>
          <span>Salvar</span>
        </button>
        <button *ngIf="editMode" pButton type="button" class="btn btn-secondary btn-md" (click)="cancelarEdicao()">
          <i class="pi pi-times mr-2"></i>
          <span>Cancelar</span>
        </button>
      </div>
    </div>
  </form>

  <div class="overflow-x-auto">
    <p-table [value]="fornecedores" class="w-full mt-6">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-2 border-b text-left">Id</th>
          <th class="p-2 border-b text-left">Nome</th>
          <th class="p-2 border-b text-left">Situação</th>
          <th class="p-2 border-b text-left">Celular</th>
          <th class="p-2 border-b text-left">Data Cadastro</th>
          <th class="p-2 border-b text-left">Data Última Modificação</th>
          <th class="p-2 border-b text-left">Ações</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-fornecedor>
        <tr>
          <td class="p-2 border-b">{{ fornecedor.id }}</td>
          <td class="p-2 border-b">{{ fornecedor.nome }}</td>
          <td class="p-2 border-b">
            <ng-container *ngIf="fornecedor.ativo !== false; else notActive">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-800">Ativo</span>
            </ng-container>
            <ng-template #notActive>
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-red-100 text-red-800">Desativado</span>
            </ng-template>
          </td>
          <td class="p-2 border-b">{{ fornecedor.celular }}</td>
          <td class="p-2 border-b">{{ fornecedor.dataCadastro | date : "dd/MM/yyyy HH:mm:ss" }}</td>
          <td class="p-2 border-b">{{ fornecedor.dataUltimaModificacao | date : "dd/MM/yyyy HH:mm:ss" }}</td>
          <td class="p-2 border-b">
            <div class="flex items-center space-x-1">
              <button pButton type="button" class="p-button-text p-button-sm text-gray-700" title="Editar fornecedor" (click)="editar(fornecedor)">
                <i class="pi pi-pencil"></i>
              </button>
              <button pButton type="button" class="p-button-text p-button-sm" [ngClass]="fornecedor.ativo ? 'text-red-600' : 'text-green-600'" [title]="fornecedor.ativo ? 'Desativar fornecedor' : 'Ativar fornecedor'" (click)="confirmarAtivarDesativar(fornecedor)">
                <i [ngClass]="fornecedor.ativo ? 'pi pi-ban text-red-600' : 'pi pi-user-plus text-green-600'"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
